<template>
  <a-card :bordered="false" :loading="pageLoading" v-if="pageLoading">
    Loading
  </a-card>
  <div v-else>
    <div
      :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'"
      v-if="pageLoading === false"
    >
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="pageLoading" class="margin-bottom">
            <div slot="title">
              <h4 class="margin-remove">Manifest LK UMPD</h4>
              <small>{{ data.header.no_lk }}</small>
            </div>

            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    @click="handlePrint"
                    class="m-display-block"
                    :loading="printLoad.manifest"
                    >UMPD Report</a-button
                  >
                </li>
                <li v-if="data.iskomisi &&
                  getAuth.username != data.user_pembuat.tlc">
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    @click="handlePrintKomisi"
                    class="m-display-block"
                    :loading="printLoad.manifestKomisi"
                    >Commision Report</a-button
                  >
                </li>
                <li v-if="data.iskomisi &&
                  getAuth.username != data.user_pembuat.tlc
                ">
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    :loading="printLoad.manifestfiktif"
                    @click="handlePrintFiktif"
                    class="m-display-block"
                    >Fictitious Name Report</a-button
                  >
                </li>
                <li v-if="data.iskomisi">
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    :loading="printLoad.manifestWtNote"
                    @click="handlePrintWtNote"
                    class="m-display-block"
                    >Approval Commision Report</a-button
                  >
                </li>
                <li v-if="getAuth.username == data.user_pembuat.tlc">
                  <!-- <a-button-group> -->
                  <a-button
                    :disabled="
                      !(
                        data.last_status == 'Revised' &&
                        getAuth.username == data.user_pembuat.tlc
                      )
                    "
                    @click="handleEdit"
                    type="dashed"
                    size="small"
                    icon="edit"
                    block
                    class="m-display-block"
                    >Edit</a-button
                  >
                  <!-- </a-button-group> -->
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>No UM PD</span>
                  <span class="m-list-desc">{{ data.header.no_um }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{
                    moment(data.header.tanggal_buat).format(
                      getDefaultDateFormat
                    )
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Total UM</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.mata_uang, data.header.total_um)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Total Amount of Use</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.mata_uang, data.header.total_pemakaian)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Remaining Balance</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.mata_uang, data.header.total_sisa_saldo)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Assignee</span>
                  <span class="m-list-desc" v-for="(items, index) in data.assignee" :key="items.tlc">
                    <div>{{index+1}}. {{items.tlc}}-{{items.nama}} </div>
                    <!-- ({{ items.kategori }};
                    {{
                      data.header.no_um.includes("PD.ITS") ? "Ins. SPPD:"+ formatCurrency('IDR', items.ins_sppd) +" | Ins. SPPD LN:"+ formatCurrency('USD', items.ins_sppd_ex) : "Ins. SPPS:"+items.ins_spps+"%"
                    }}) -->
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>Category</span>
                  <span class="m-list-desc">{{
                    data.isparsial=='1' ? "PARSIAL" : "FINAL"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{
                    data.header.catatan ? data.header.catatan : '-'
                  }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-collapse v-if="getScreen" class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Usage Details</h4>
              <a-list
                itemLayout="vertical"
                :dataSource="data.detail_invoice"
                :pagination="pagination"
              >
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <span slot="title">{{
                      item.deskripsi ? item.deskripsi : "Terima Uang Muka"
                    }}</span>
                    <div slot="description" class="margin-remove">
                      <span>{{
                        moment(item.tanggal).format(getDefaultDateFormat)
                      }}</span>
                      <div>
                        <span>{{ item.label }}</span>
                        <h4 class="margin-remove">
                          {{ formatCurrency(data.mata_uang, item.nilai) }}
                        </h4>
                      </div>
                      <a-button-group v-if="data.user_pembuat.tlc == getAuth.username" class="margin-top">
                        <a-button type="primary" icon="edit" @click="handleUploadDoc(item)"></a-button>
                        <a-button type="default" icon="eye" @click="viewlampiranDoc(item.lampiran_path)" v-if="item.lampiran">View</a-button>
                        <a-button type="default" disabled v-else>No File</a-button>
                      </a-button-group>
                      <a v-else-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)" class="margin-top">
                        View Document
                      </a>
                      <div v-else class="margin-top">
                        :: No File Uploaded ::
                      </div>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Usage Details</h4>
              <a-input-search
                v-model="search"
                placeholder="Quick Search"
                allowClear
                :change="searching"
                class="margin-bottom"
              />
              <a-table
                :columns="columns"
                :dataSource="tableData"
                :pagination="pagination"
                size="small"
                bordered
                :scroll="{ x: 950 }"
              >
                <span slot="debit" slot-scope="debit">
                  <CurrencyJustified
                    v-if="debit.val"
                    :currencyValue="debit.curr"
                    :valueNumber="debit.val"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <div slot="description" slot-scope="item">
                  <h4 class="margin-remove">{{ item.deskripsi }}</h4>
                  <span>{{ item.nm_um }}</span>
                </div>
                <template slot="document" slot-scope="index, item">
                  <span v-if="item.deskripsi.toLowerCase() == 'terima uang muka'"></span>
                  <a-button-group v-else-if="data.user_pembuat.tlc == getAuth.username" class="margin-top">
                    <a-button type="primary" icon="edit" @click="handleUploadDoc(item)"></a-button>
                    <a-button type="default" icon="eye" @click="viewlampiranDoc(item.lampiran_path)" v-if="item.lampiran">View</a-button>
                    <a-button type="default" disabled v-else>No File</a-button>
                  </a-button-group>
                  <a v-else-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
                    View Document
                  </a>
                  <span v-else>
                    No File Uploaded
                  </span>
                </template>
                <span slot="kredit" slot-scope="kredit">
                  <CurrencyJustified
                    v-if="kredit.val"
                    :currencyValue="kredit.curr"
                    :valueNumber="kredit.val"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="sisa" slot-scope="sisa">
                  <CurrencyJustified
                    :currencyValue="sisa.curr"
                    :valueNumber="sisa.val"
                  />
                </span>
                <div slot="footer" class="padding-all">
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      >Total UM</a-col
                    >
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="data.mata_uang"
                        :valueNumber="data.header.total_um"
                      />
                    </a-col>
                    <a-col
                      :span="3"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      >Total Amount of Use</a-col
                    >
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="data.mata_uang"
                        :valueNumber="data.header.total_pemakaian"
                      />
                    </a-col>
                    <a-col
                      :span="3"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      >Remaining Balance</a-col
                    >
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="data.mata_uang"
                        :valueNumber="data.header.total_sisa_saldo"
                      />
                    </a-col>
                    <a-col
                      :span="3"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                  </a-row>
                </div>
              </a-table>
            </a-collapse-panel>
          </a-collapse>
          <template v-if="!getScreen">
            <a-alert
              v-if="
                data.jenis.toLowerCase() == 'close' &&
                data.status_close.toLowerCase() !== 'true'
              "
              class="margin-top"
              message="Process Cash-in at BKM first"
              banner
            />
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-else-if="
                (data.jenis.toLowerCase() !== 'manifest' &&
                  data.jenis.toLowerCase() !== 'transfer') ||
                (data.jenis.toLowerCase() == 'close' &&
                  data.status_close.toLowerCase() == 'true')
              "
            >
              <div slot="title">Manifest actions</div>

              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Action">
                  <a-select
                    showSearch
                    v-decorator="['aksi', { rules: [{ required: true }] }]"
                  >
                    <a-select-option
                      v-for="item in data.aksi"
                      :key="item.aksi"
                      >{{ item.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </template>
            </a-card>
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-if="
                data.jenis.toLowerCase() === 'transfer' && data.status_transfer
              "
            >
              <div slot="title">Manifest actions</div>
              <div slot="extra">
                <h5 class="m-text-align right margin-remove">
                  Remaining balance
                </h5>
                <h4 class="m-text-align right margin-remove">
                  {{ formatCurrency(data.mata_uang, data.sisa_tf) }}
                </h4>
              </div>

              <a-form :form="form">
                <a-form-item label="Action">
                  <a-select
                    @change="onChangeStatus"
                    showSearch
                    v-decorator="[
                      'status',
                      {
                        rules: [{ required: true }],
                        initialValue: data.aksi[0].aksi,
                      },
                    ]"
                  >
                    <a-select-option
                      v-for="item in data.aksi"
                      :key="item.aksi"
                      >{{ item.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item
                  label="Transfer date"
                  v-if="aksiSelected === 'Transferred' || aksiSelected === 'Upload BA' || aksiSelected === ''"
                >
                  <a-date-picker
                    placeholder="Select Date"
                    :format="getDefaultDateFormat"
                    v-decorator="['tgl_trf', { rules: [{ required: true }] }]"
                  />
                </a-form-item>
                <a-form-item
                  :label="aksiSelected === 'Upload BA' ? 'Document BA' : 'Evidence of transfer'"
                  v-if="aksiSelected === 'Transferred' || aksiSelected === 'Upload BA'|| aksiSelected === ''"
                >
                  <a-upload
                    accept="image/*"
                    :showUploadList="true"
                    :fileList="push"
                    listType="picture"
                    :beforeUpload="beforeUpload"
                    v-decorator="[
                      'upload',
                      { rules: [{ required: true }] },
                      { valuePropName: 'push' },
                    ]"
                  >
                    <a-button>
                      <a-icon type="upload" />&nbsp;Select your file
                    </a-button>
                  </a-upload>
                </a-form-item>
                <a-form-item
                  label="Transfer Value"
                  v-if="aksiSelected === 'Transferred' || aksiSelected === 'Upload BA'|| aksiSelected === ''"
                >
                  <a-input-number
                    :disabled="disabled"
                    type="number"
                    :max="Number(data.sisa_tf.toFixed(2))"
                    class="m-width-full m-text-align right"
                    :formatter="
                      (value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    "
                    :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                    v-decorator="[
                      'value_transferan',
                      {
                        rules: [{ required: true }],
                        initialValue: data.sisa_tf.toFixed(2),
                      },
                    ]"
                  />
                </a-form-item>
                <a-checkbox
                  v-if="aksiSelected === 'Transferred' || aksiSelected === 'Upload BA'|| aksiSelected === ''"
                  class="margin-bottom"
                  @change="handleCheckData"
                  :checked="checkTransferValue"
                  :disabled="aksiSelected === 'Upload BA'"
                  >The transferred value matches the remaining
                  balance</a-checkbox
                >
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['remark']"
                    :disabled="aksiSelected === 'Upload BA'"
                  />
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </template>
            </a-card>
          </template>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-card :loading="pageLoading" :class="getScreen ? 'margin-top' : ''">
            <div slot="title">{{data.last_status=='Upload BA' ? 'Document BA' : 'Transfer Receipt'}}</div>
            <div>
              <a-alert
                v-if="data.bukti_transfer.length <= 0"
                type="error"
                message="No evidence of transfer was uploaded!"
                banner
              />
              <a-list
                itemLayout="horizontal"
                :dataSource="data.bukti_transfer"
                v-else
              >
                <Empty
                  v-if="
                    data.bukti_transfer
                      ? data.bukti_transfer.length <= 0
                      : data.bukti_transfer
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between">
                      <h3 class="margin-remove">
                        {{ moment(item.tgl_tf).format(getDefaultDateFormat) }}
                      </h3>
                      <a-button
                        @click="handleViewBt(item)"
                        size="small"
                        type="default"
                        icon="eye"
                        >View</a-button
                      >
                    </div>
                    <div slot="title" class="m-display-flex">
                      <h4 class="margin-remove" v-if="data.last_status !='Upload BA'">
                        {{ formatCurrency(item.currency, item.value_tf) }}
                      </h4>
                    </div>
                    <img
                      class="m-image-icon"
                      slot="avatar"
                      :src="$serviceUrl + item.url"
                    />
                    <p slot="description" class="margin-remove">
                      {{ item.user_tf }}
                    </p>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
          </a-card>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Transaction Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-tooltip class="m-tooltip-inner" placement="bottomLeft">
                    <template slot="title">
                      <span>History</span>
                    </template>
                    <a-button
                      @click="historyToggle"
                      type="default"
                      size="small"
                      class="margin-right-small"
                    >
                      <a-icon type="clock-circle-o" />
                    </a-button>
                  </a-tooltip>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.user_pembuat.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(data.user_pembuat.tanggal).format(
                          getDefaultDateFormat
                        )
                      }}
                    </h4>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">{{ data.user_pembuat.status }}</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                  :color="
                    workflow.status === 'On Process' ||
                    workflow.status === 'Delivered'
                      ? 'red'
                      : workflow.status === 'Waiting'
                      ? 'grey'
                      : 'green'
                  "
                >
                  <div class="m-timeline-title">
                    {{ workflow.job_desc }}
                    {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                  </div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark !== ''">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleView(item)"
                        >{{ item.header }} | {{ item.tlc }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span
                      >
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div
                      slot="title"
                      v-if="item.value_transaksi && item.rest_api !== 'sppds'"
                    >
                      <span class="m-timeline-title">{{
                        formatCurrency(item.currency, item.value_transaksi)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <template v-if="getScreen">
            <a-alert
              v-if="
                data.jenis.toLowerCase() == 'close' &&
                data.status_close.toLowerCase() !== 'true'
              "
              class="margin-top"
              message="Process Cash-in at BKM first"
              banner
            />
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-else-if="
                (data.jenis.toLowerCase() !== 'manifest' &&
                  data.jenis.toLowerCase() !== 'transfer') ||
                (data.jenis.toLowerCase() == 'close' &&
                  data.status_close.toLowerCase() == 'true')
              "
            >
              <div slot="title">Manifest actions</div>

              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Action">
                  <a-select
                    showSearch
                    v-decorator="['aksi', { rules: [{ required: true }] }]"
                  >
                    <a-select-option
                      v-for="item in data.aksi"
                      :key="item.aksi"
                      >{{ item.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </template>
            </a-card>
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-if="
                data.jenis.toLowerCase() === 'transfer' && data.status_transfer
              "
            >
              <div slot="title"></div>
              <div slot="extra">
                <h5 class="m-text-align right margin-remove">
                  Remaining balance
                </h5>
                <h4 class="m-text-align right margin-remove">
                  {{ formatCurrency(data.mata_uang, data.sisa_tf) }}
                </h4>
              </div>

              <a-form :form="form">
                <a-form-item label="Action">
                  <a-select
                    @change="onChangeStatus"
                    showSearch
                    v-decorator="[
                      'status',
                      {
                        rules: [{ required: true }],
                        initialValue: data.aksi[0].aksi,
                      },
                    ]"
                  >
                    <a-select-option
                      v-for="item in data.aksi"
                      :key="item.aksi"
                      >{{ item.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item
                  label="Transfer date"
                  v-if="aksiSelected === 'Transferred' || aksiSelected === 'Upload BA' || aksiSelected === ''"
                >
                  <a-date-picker
                    placeholder="Select Date"
                    :format="getDefaultDateFormat"
                    v-decorator="['tgl_trf', { rules: [{ required: true }] }]"
                  />
                </a-form-item>
                <a-form-item
                  label="Evidence of transfer"
                  v-if="aksiSelected === 'Transferred' || aksiSelected === 'Upload BA' || aksiSelected === ''"
                >
                  <a-upload
                    accept="image/*"
                    :showUploadList="true"
                    :fileList="push"
                    listType="picture"
                    :beforeUpload="beforeUpload"
                    v-decorator="[
                      'upload',
                      { rules: [{ required: true }] },
                      { valuePropName: 'push' },
                    ]"
                  >
                    <a-button>
                      <a-icon type="upload" />&nbsp;Select your file
                    </a-button>
                  </a-upload>
                </a-form-item>
                <a-form-item
                  label="Transfer Value"
                  v-if="aksiSelected === 'Transferred' || aksiSelected === 'Upload BA' || aksiSelected === ''"
                >
                  <a-input-number
                    :disabled="disabled"
                    type="number"
                    :max="Number(data.sisa_tf.toFixed(2))"
                    class="m-width-full m-text-align right"
                    :formatter="
                      (value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    "
                    :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                    v-decorator="[
                      'value_transferan',
                      {
                        rules: [{ required: true }],
                        initialValue: data.sisa_tf.toFixed(2),
                      },
                    ]"
                  />
                </a-form-item>
                <a-checkbox
                  v-if="aksiSelected === 'Transferred' || aksiSelected === 'Upload BA' || aksiSelected === ''"
                  class="margin-bottom"
                  @change="handleCheckData"
                  :checked="checkTransferValue"
                  :disabled="aksiSelected === 'Upload BA'"
                  >The transferred value matches the remaining
                  balance</a-checkbox
                >
                <a-form-item label="Note" >
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['remark']"
                    :disabled="aksiSelected === 'Upload BA'"
                  />
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </template>
            </a-card>
          </template>
        </a-col>
      </a-row>
    </div>
    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="clock-circle-o" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }}
                {{ history.tlc_to ? "|" + history.tlc_to : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <div class="margin-top"></div>
      <a-divider class="margin-small" />
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>

    <a-modal v-model="visibleUploadDoc" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="upload" />&nbsp;Upload Transaction Document </span>
      <a-spin tip="Your document is being processed, do not leave this page!" :spinning="uploadDoc.loading"
      >
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <b>Tanggal</b>
          </a-col><a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
            <a-input v-model="uploadDoc.tanggal" disabled></a-input>
          </a-col>
        </a-row>
        <a-row :gutter="8" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>Description</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <a-textarea v-model="uploadDoc.deskripsi" disabled></a-textarea>
            </a-col>
        </a-row>
        <a-row :gutter="8" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>Transaction Document</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 1 }">:</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <a-upload
                :showUploadList="true"
                :fileList="uploadDoc.doctransfiles"
                :beforeUpload="beforedoctransUpload"
                v-model="uploadDoc.file"
                :disabled="uploadDoc.loading"
              >
              <!-- :remove="handledoctransRemove" -->
                <a-button>
                  <a-icon type="upload" />&nbsp;Select File
                </a-button>
              </a-upload>
            </a-col>
        </a-row>
      </a-spin> 
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";

export default {
  name: "ManifestLaporanUmpd",
  components: { Status },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      previewVisible: false,
      previewImage: "",
      visibleHistory: false,
      pageLoading: true,
      disabled: true,
      data: {},
      push: [],
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      tableData: [],
      tableDataTemp: [],
      search: "",
      printLoad: {
        manifest: false,
        manifestkomisi: false,
        manifestfiktif: false,
        manifestWtNote: false
      },
      aksiSelected: "",
      checkTransferValue: true,
      visibleUploadDoc: false,
      uploadDoc: {
        file: null,
        doctransfiles: null,
        id_dtl_trans: null,
        tanggal: null,
        deskripsi: null,
        loading: false,
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();

    if (!this.getScreen) {
      this.getDetailPemakaianWeb();
    }
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.push = [];
        this.checkTransferValue = true;
        this.disabled = true;
        this.search = "";
      }

      if (!this.getScreen) {
        this.getDetailPemakaianWeb();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStandartFormatDate",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 75,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Date",
          dataIndex: "tanggal",
          width: 100,
          key: "tanggal",
          sorter: (a, b) =>
            new Date(
              moment(a.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ) -
            new Date(
              moment(b.tanggal, this.getDefaultDateFormat).format(
                this.getStandartFormatDate
              )
            ),
        },
        {
          title: "Description",
          scopedSlots: { customRender: "description" },
          key: "deskripsi",
          width: 300,
          sorter: (a, b) => a.deskripsi.length - b.deskripsi.length,
        },
        {
          title: "Document",
          key: "document",
          scopedSlots: { customRender: "document" },
          width: 150,
          align: "center"
        },
        {
          title: "Debit",
          dataIndex: "debit",
          key: "debit",
          sorter: (a, b) => a.debit.length - b.debit.length,
          scopedSlots: { customRender: "debit" },
        },
        {
          title: "Credit",
          dataIndex: "kredit",
          key: "kredit",
          sorter: (a, b) => a.kredit.length - b.kredit.length,
          scopedSlots: { customRender: "kredit" },
        },
        {
          title: "Balance",
          dataIndex: "sisa",
          key: "sisa",
          sorter: (a, b) => a.sisa.length - b.sisa.length,
          scopedSlots: { customRender: "sisa" },
        },
      ];
      return kolom;
    },

    searching() {
      if (this.search) {
        this.tableData = this.tableData.filter(
          (obj) =>
            obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            moment(obj.tanggal, "DD-MM-YYYY")
              .format("DD-MM-YYYY")
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        this.tableData = this.tableDataTemp;
      }

      return this.tableData;
    },
  },
  methods: {
    moment,
    fetchManifest() {
      axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pd",
        params: {
          tlc: this.getAuth.username,
          id_manifest: this.id,
          user_pembuat: this.user_pembuat,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = {
            header: {
              no_um: response.data.invoice[0].no_um,
              no_lk: response.data.invoice[0].no_lk,
              tanggal_buat: response.data.invoice[0].tgl_buat,

              total_um: Number(response.data.invoice[0].total_um_1) || 0,
              total_pemakaian:
                Number(response.data.invoice[0].total_pemakaian_1) || 0,
              total_sisa_saldo:
                Number(response.data.invoice[0].total_sisa_saldo_1) || 0,
            },
            assignee: response.data.assignee,
            jenis: response.data.jenis,
            status_close: response.data.status_close,
            last_status: response.data.invoice[0].status,
            user_pembuat: {
              tlc: response.data.invoice[0].tlc,
              tanggal: response.data.invoice[0].tgl_buat,

              status: "Created",
            },
            sisa_tf: response.data.sisa_tf,
            aksi: response.data.aksi,
            bukti_transfer: response.data.detail_bukti_transfer,
            detail_invoice: response.data.dtl_invoice,
            dokumen_terkait: response.data.dokumen_terkait,
            status: response.data.status_app,
            history: response.data.notifikasi,
            mata_uang: response.data.invoice[0].currency,
            status_transfer: response.data.status_transfer,
            isparsial: response.data.isparsial,
            iskomisi: response.data.iskomisi,
          };

          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          this.$router.go(-1);
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handlePrint(item) {
      this.printLoad.manifest = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pd/cetak_laporan_um_pd",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_lk: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.pageLoading = false;
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          this.printLoad.manifest = false;
          this.$router.go(-1);
        });
    },
    handlePrintKomisi(item) {
      this.printLoad.manifestkomisi = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pd/cetak_laporan_um_pd_komisi",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_lk: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.pageLoading = false;
          this.printLoad.manifestkomisi = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          this.printLoad.manifestkomisi = false;
          this.$router.go(-1);
        });
    },
    handlePrintFiktif() {
      this.printLoad.manifestfiktif = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pd/cetak_laporan_um_pd_komisi",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_lk: this.id,
          fiktif:"1",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifestfiktif = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifestfiktif = false;
          this.$router.go(-1);
        });
    },
    handlePrintWtNote() {
      this.printLoad.manifestWtNote = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pd/cetak_laporan_um_pd_tanpa_nota",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_lk: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifestWtNote = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifestWtNote = false;
          this.$router.go(-1);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "lapUmpdEdit",
        params: { id: this.id, type: "revised" },
      });
    },
    handleAction() {
      if (this.data.jenis.toLowerCase() === "transfer") {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }

          let post = new FormData();
          if (values.status === "Revised") {
            post.append("id_lk", this.id);
            post.append("tlc", this.getAuth.username);
            post.append("status", values.status);
            post.append("remark", values.remark ? values.remark : "");
          } else {
            post.append("id_lk", this.id);
            post.append("tlc", this.getAuth.username);
            post.append("status", values.status);
            post.append("remark", values.remark ? values.remark : "");
            post.append(
              "tgl_tf",
              moment(values.tgl_trf).format(this.getStandartFormatDate)
            );
            post.append("value_transferan", values.value_transferan);
            post.append("file_transfer", this.push[0]);
          }

          axios({
            method: "post",
            url: this.$serviceUrl + "lap_um_pd/approval ",
            processData: false,
            data: post,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go();
            })
            .catch((err) => {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses.message);
            });
        });
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("choose-action");
            return;
          }

          axios({
            method: "post",
            url: this.$serviceUrl + "lap_um_pd/approval ",
            processData: false,
            data: {
              id_lk: this.id,
              tlc: this.getAuth.username,
              status: values.aksi,
              remark: values.catatan ? values.catatan : "",
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go();
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      }
    },
    handleCheckData(e) {
      if (e.target.checked) {
        this.disabled = true;
        this.checkTransferValue = true;
        this.form.setFieldsValue({
          value_transferan: this.data.sisa_tf.toFixed(2),
        });
      } else {
        this.disabled = false;
        this.checkTransferValue = false;
        this.form.setFieldsValue({
          value_transferan: 0,
        });
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleViewBt(file) {
      if (file.url.substr(file.url.length - 3) === "pdf") {
        window.open(this.$serviceUrl + file.url, "_blank");
      } else {
        this.previewImage = this.$serviceUrl + file.url;
        this.previewVisible = true;
      }
    },
    getDetailPemakaianWeb() {
      axios({
        method: "get",
        url: this.$serviceUrl + "lap_um_pd/web_detil_pemakaian",
        params: {
          id: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let dataPemakaian = response.data.detail_pemakaian;

          response.data.detail_pemakaian.forEach((value, index) => {
            if (value.debit !== "-") {
              dataPemakaian[index]["debit"] = {
                curr: value.currency,
                val: Number(value.debit),
              };
            }

            if (value.kredit !== "-") {
              dataPemakaian[index]["kredit"] = {
                curr: value.currency,
                val: Number(value.kredit),
              };
            }
            dataPemakaian[index]["sisa"] = {
              curr: value.currency,
              val: Number(value.sisa),
            };
            dataPemakaian[index]["tanggal"] = moment(value.tanggal).format(
              this.getDefaultDateFormat
            );
          });

          this.tableData = dataPemakaian;
          this.tableDataTemp = dataPemakaian;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          this.$router.go(-1);
        });
    },
    onChangeStatus(item) {
      this.aksiSelected = item;
      if (item == "Revised") {
        this.disabled = false;
        this.push = [];
      } else {
        this.disabled = true;
        this.checkTransferValue = true;

        this.$nextTick(function () {
          this.form.setFieldsValue({
            remark: this.aksiSelected == 'Upload BA' ? 'Upload Berita Acara Penyelesaian Uang Muka' : '',
          });
        });
      }
    },
    handleActionConfirm() {
      this.confirmMessage("confirm-save");
    },
    viewlampiranDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    handleUploadDoc(item) {
      this.visibleUploadDoc = true;
      this.uploadDoc.tanggal = item.tanggal;
      this.uploadDoc.deskripsi = item.deskripsi;
      this.uploadDoc.id_dtl_trans = item.id_dtl;
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        let data = new FormData();
        data.append("tipe_trans", "lap_um_pp");
        data.append("id_dtl_trans", this.uploadDoc.id_dtl_trans);
        data.append("file_upload", file);

        this.uploadDoc.loading = true;
        this.asyncAxiosPost("main/upload_lampiran", "formdata", this.getAuth, data)
          .then((response) => {
            if (response.status && response.status == true) {
              this.displayMessageValue("success-other", response.message);
            } else {
              let responses = Object.assign({}, response);
              this.displayMessageValue("error-other", responses);
            }
            this.uploadDoc.loading = false;
            this.getDetailPemakaianWeb();
            this.visibleUploadDoc = false;
          })
          .catch((err) => {
            console.log(err);
            this.uploadDoc.loading = false;
            if (err.response && err.response.data) {
              this.$notification.error({
                message: "Error Message",
                description: err.response.data.message,
              });
            } else {
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
            }
          });
        this.uploadDoc.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.uploadDoc.doctransfiles = [];
    },
    viewLampDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    }
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleAction);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleAction);
  },
};
</script>

<style scoped lang="less">
.m-image-icon {
  width: 50px;
}
</style>
